import { now, offsetDateTimeToMs } from "@freightsimple/time/helpers";
import { useCallback, useState } from "react";

const STORAGE_KEY = "photoUploadReminderDismissed";
// 30 days: long enough not to nag, short enough to resurface if the customer
// still isn't uploading photos
const THIRTY_DAYS_MS = 2592e6;

const readDismissedState = (): boolean => {
  const expiryTimestamp = localStorage.getItem(STORAGE_KEY);
  if (!expiryTimestamp) return false;

  const expiryTime = parseInt(expiryTimestamp, 10);
  if (isNaN(expiryTime)) return false;
  return expiryTime > offsetDateTimeToMs(now());
};

export function useDashboardPhotoUploadReminderDismissed() {
  const [isDismissed, setIsDismissed] = useState(readDismissedState);

  const dismiss = useCallback(() => {
    setIsDismissed(true);
    const expiryTime = offsetDateTimeToMs(now()) + THIRTY_DAYS_MS;
    localStorage.setItem(STORAGE_KEY, expiryTime.toString());
  }, []);

  return { isDismissed, dismiss };
}
